import * as types from '../const/action.types';

export function product(state = {}, action) {
    switch (action.type) {
        case types.LOAD_PRODUCT_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function products(state = [], action) {
    switch (action.type) {
        case types.PRODUCTS_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function workstation(state = [], action) {
    switch (action.type) {
        case types.LOAD_WORKSTATION_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function productsHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.PRODUCTS_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function productsIsLoading(state = false, action) {
    switch (action.type) {
        case types.PRODUCTS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/product.reducer.js